export const PER_PAGE = 20;
